import { AxiosError } from 'axios';
import { useMutation } from 'react-query';
import { POST_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { Axios } from '@utils/api/axios-instance.ts';

export type BillingChannel = 'SCRIPTIX' | 'ON_PREM';

interface SubscribePlanPayload {
  customer_id: number;
  auto_renew: boolean;
  billing_channel?: BillingChannel;
}

export const useSubscribePlan = () => {
  const subscribePlan = async ({
    id,
    payload
  }: {
    id: string;
    payload: SubscribePlanPayload;
  }) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const response = await Axios.post<any>(`${POST_URL(id).sell}`, payload);
    return response.data;
  };

  return useMutation<
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    any,
    AxiosError<BaseError>,
    { id: string; payload: SubscribePlanPayload }
  >(subscribePlan, {
    useErrorBoundary: false
  });
};
